import { Classe, Studente } from "../..";


export interface IscrizioneStudenteResponse {
  classe?: Classe;
  studente?: Studente;
  nomeScuola?: string;
}
